var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from "../di/injectable";
var Observer = /** @class */ (function () {
    function Observer() {
        this._observers = {};
    }
    Observer.prototype.subscribe = function (eventName, callback) {
        if (!this._observers[eventName]) {
            this._observers[eventName] = [];
        }
        this._observers[eventName].push(callback);
    };
    Observer.prototype.unsubscribe = function (eventName, callback) {
        if (!this._observers[eventName]) {
            return;
        }
        this._observers[eventName] = this._observers[eventName].filter(function (obj) { return obj !== callback; });
    };
    Observer.prototype.unsubscribeAll = function (eventName) {
        if (!this._observers[eventName]) {
            return;
        }
        this._observers[eventName] = [];
    };
    Observer.prototype.notify = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this._observers[eventName]) {
            return;
        }
        this._observers[eventName].forEach(function (callback) {
            callback.apply(void 0, args);
        });
    };
    Observer.prototype.getObservers = function (eventName) {
        return this._observers[eventName];
    };
    Observer = __decorate([
        Injectable()
    ], Observer);
    return Observer;
}());
export { Observer };
//# sourceMappingURL=observer.js.map